// nalvp.com
export const envUrls = {
  baseUrl: "https://nalvp.com/",
  apiUrl: "https://nalvp.com",
  clientID:
    "640318544629-d5apupufb91os18tgm3g0fgssaipkvcp.apps.googleusercontent.com",
};

export const authURL = `https://accounts.google.com/o/oauth2/auth?client_id=${envUrls?.clientID}&redirect_uri=${envUrls?.baseUrl}&response_type=token&scope=email%20profile&prompt=login`;
